import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'common/Modal';
import StaffForm from '../StaffForm';

export default function AddModal({
  autoRosterDistrict, closeModal, modalOpen, updateTable,
  userIsSysadmin, flags, contactTypeOptions, strictPasswordPolicies
}) {
  return (
    <Modal
      closeModal={closeModal}
      headerText="Add Staff"
      isOpen={modalOpen}
    >
      <StaffForm
        autoRosterDistrict={autoRosterDistrict}
        closeModal={closeModal}
        contactTypeOptions={contactTypeOptions}
        flags={flags}
        strictPasswordPolicies={strictPasswordPolicies}
        updateTable={updateTable}
        userIsSysadmin={userIsSysadmin}
      />
    </Modal>
  );
}

AddModal.propTypes = {
  autoRosterDistrict: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  contactTypeOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  flags: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
  modalOpen: PropTypes.bool.isRequired,
  strictPasswordPolicies: PropTypes.instanceOf(Array).isRequired,
  updateTable: PropTypes.func.isRequired,
  userIsSysadmin: PropTypes.bool.isRequired,
};
